<smrts-page primaryTitle="Painel Financeiro">

  <div class="content">
    <mat-card>
      
      <div class="wrapper">
        <h2 class="accent-color">Gerenciar Contas do Caixa</h2>
        <div class="inline-element gerenciar-contas-btns">
          <p-floatLabel variant="on">
            <p-iconField iconPosition="left">
              <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
              <input
                pInputText
                id="buscarContaCaixa"
                (input)="dtCaixa.filterGlobal($any($event.target).value, 'contains')" />
            </p-iconField>
            <label for="buscarContaCaixa">Buscar conta</label>
          </p-floatLabel>
          <mat-divider [vertical]="true" class="vertical-mat-divider"></mat-divider>
          <a routerLink="/movimentacao-caixa" mat-raised-button>Abrir</a>
        </div>
      </div>

      <div class="table-container">
        <p-table #dtCaixa [value]="contasCaixa" responsiveLayout="scroll" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25,50, 100]" [globalFilterFields]="['nome']">
          <ng-template pTemplate="header">
            <tr>
              <th>Nome</th>
              <th>Saldo</th>
              <th>Data do último lançamento</th>
              <th>Receita</th>
              <th>Despesa</th>
            </tr>
          </ng-template>
          <ng-template #body let-element let-rowIndex="rowIndex">
            <tr [pSelectableRow]="element" [pSelectableRowIndex]="rowIndex">
              <td>{{ element.nome }}</td>
              <td>{{ element.saldo | currency:'BRL' }}</td>
              <td>{{ element.ultimoLancamento | date:'dd/MM/yyyy' }}</td>
              <td>{{ element.receita | currency:'BRL' }}</td>
              <td>{{ element.despesa | currency:'BRL' }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </mat-card>

    
    <mat-card>
      <div class="wrapper">
        <h2 class="accent-color">Gerenciar Conciliação das Contas do Banco</h2>
        <div class="inline-element gerenciar-contas-btns">
          <p-floatLabel variant="on">
            <p-iconField iconPosition="left">
              <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
              <input
                pInputText
                id="buscarContaBanco"
                (input)="dtBanco.filterGlobal($any($event.target).value, 'contains')" />
            </p-iconField>
            <label for="buscarContaBanco">Buscar conta</label>
          </p-floatLabel>
          <mat-divider [vertical]="true" class="vertical-mat-divider"></mat-divider>
          <button mat-raised-button (click)="importContaBanco.click()">Adicionar</button>
          <input #importContaBanco type="file" class="display-none" [accept]="excelFileType"
            (change)="importarConciliacao(importContaBanco)">
        </div>
      </div>


      <div class="table-container">
        <p-table #dtBanco [value]="contasBanco" responsiveLayout="scroll" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25,50, 100]" [globalFilterFields]="['nome']">
          <ng-template pTemplate="header">
            <tr>
              <th>Nome</th>
              <th>Ultima Conciliação</th>
              <th>Saldo</th>
              <th>Banco de Origem</th>
              <th class="icon-column"></th>
            </tr>
          </ng-template>
          <ng-template #body let-element let-rowIndex="rowIndex">
            <tr [pSelectableRow]="element" [pSelectableRowIndex]="rowIndex">
              <td>{{ element.nome }}</td>
              <td>{{ element.ultimaConciliacao | date:'dd/MM/yyyy' }}</td>
              <td>{{ element.saldo | currency:'BRL' }}</td>
              <td>{{ element.nomeBancoOrigem }}</td>
              <td>
                <div class="inline-element">
                  <a [disableNoPermission]="permissaoVisualizarConciliacao" [routerLink]="'/conciliacao/'+element.id" class="accent-color" mat-icon-button matTooltip="Nova conciliação">
                    <mat-icon>add</mat-icon>
                  </a>
                  <a [disableNoPermission]="permissaoVisualizarConciliacao" [routerLink]="'/historico-conciliacao/'+element.id" class="accent-color" mat-icon-button matTooltip="Abrir histórico">
                    <mat-icon>history</mat-icon>
                  </a>
                  <button class="accent-color" mat-icon-button [matMenuTriggerFor]="menuConta">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                </div>

                <mat-menu #menuConta="matMenu" xPosition="before">
                  <button mat-menu-item (click)="importExtrato.click()">Importar Extrato</button>
                  <button mat-menu-item (click)="importCaixa.click()">Importar do Caixa</button>

                  <input #importExtrato type="file" class="display-none"
                    [accept]="element.tipoContaBanco === tipoContaBancoCartao ? csvFileType : excelFileType"
                    (change)="importLancamentos(importExtrato, element, origemLancamentoBanco)">
                  <input #importCaixa type="file" class="display-none" [accept]="excelFileType" (change)="importLancamentos(importCaixa, element, origemLancamentoCaixa)">
                </mat-menu>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </mat-card>
  </div>

</smrts-page>